import React from "react";
import { Row, Col, Divider } from "antd";

//component
import IncomeByStaffList from "./component/income_by_staff";
import VoucherSoldList from "./component/voucher_sold";
import CreditNote from "./component/credit_note";
import CashUpTotal from "./component/cashup_total";

const IncomeByStaffDetail = ({ edit, sumTotal, incomes }) => {
  // -------------------------- VAR --------------------------
  // -------------------------- STATE --------------------------
  // -------------------------- REDUX --------------------------

  // -------------------------- FUNCTION --------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN --------------------------
  return (
    <Col
      style={{
        borderColor: "#d9d9d9",
        borderWidth: "1px",
        borderStyle: "solid",
        borderRadius: "10px",
        marginTop: 10,
      }}
    >
      <Col xl={24} lg={24} md={24} xs={24} align="left">
        <CashUpTotal total={sumTotal} color="green" />
      </Col>
      <Col xl={24} lg={24} md={24} xs={24} align="left">
        <IncomeByStaffList edit={edit} incomes={incomes} />
      </Col>
      <Col xl={24} lg={24} md={24} xs={24} align="left">
        <VoucherSoldList edit={edit} />
      </Col>
      <Col xl={24} lg={24} md={24} xs={24} align="left">
        <CreditNote edit={edit} />
      </Col>
    </Col>
  );
};

export default IncomeByStaffDetail;
